import { registerComponent } from '@studiometa/js-toolkit';
import { Frame, Figure } from '@studiometa/ui';

registerComponent(Frame);
registerComponent(Figure);
